import{__require as r}from"./global-this.js";import{__require as e}from"./is-object.js";var t,i;function n(){if(i)return t;i=1;var n=r(),o=e(),u=n.document,a=o(u)&&o(u.createElement);return t=function(r){return a?u.createElement(r):{}}}export{n as __require};
//# sourceMappingURL=document-create-element.js.map
